import React from "react";
import ReactDOM from "react-dom";

const MobileMenu = ({ isOpen, closeMobileNav, location }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <nav
            className="navbar navbar-mobile"
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: "rgba(51, 60, 79, 0.9)",
                zIndex: 1000,
            }}
        >
            <i
                className="bi mobile-nav-toggle bi-x"
                onClick={closeMobileNav}
                style={{ position: "absolute", top: "15px", right: "15px", fontSize: "28px", cursor: "pointer" }}
            ></i>
            <ul
                style={{
                    display: "block",
                    position: "absolute",
                    top: "55px",
                    right: "15px",
                    bottom: "15px",
                    left: "15px",
                    padding: "10px 0",
                    borderRadius: "6px",
                    backgroundColor: "#fff",
                    overflowY: "auto",
                    transition: "0.3s",
                }}
            >
                <li>
                    <a
                        className={`nav-link scrollto ${location.pathname === "/#open_data" ? "active" : ""}`}
                        href="#open_data"
                        onClick={closeMobileNav}
                    >
                        Open Data
                    </a>
                </li>
                <li>
                    <a
                        className={`nav-link scrollto ${location.pathname === "/#dashboard" ? "active" : ""}`}
                        href="#dashboard"
                        onClick={closeMobileNav}
                    >
                        Dashboard
                    </a>
                </li>
                <li>
                    <a
                        className={`nav-link scrollto ${location.pathname === "/#peta_digital" ? "active" : ""}`}
                        href="#peta_digital"
                        onClick={closeMobileNav}
                    >
                        Peta Digital
                    </a>
                </li>
                <li className="dropdown">
                    <a
                        className={`nav-link scrollto ${location.pathname === "/#statistik_sektoral" ? "active" : ""}`}
                        href="#statistik_sektoral"
                        onClick={closeMobileNav}
                    >
                        <span>Statistik Sektoral</span> <i className="bi bi-chevron-down"></i>
                    </a>
                    <ul>
                        <li>
                            <a href="https://romantik.web.bps.go.id/" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                Rekomendasi Statistik
                            </a>
                        </li>
                        <li>
                            <a href="https://indah.bps.go.id/" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                Metadata Statistik
                            </a>
                        </li>
                        <li>
                            <a href="https://www.bps.go.id/id/publication/2026/01/15/c733974d5ab8e5901826c2a8/standar-data-statistik-2025.html" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                Standar Data Statistik
                            </a>
                        </li>
                        <li>
                            <a href="https://diskominfo.sampangkab.go.id/unit-kerja/SDP?page=sop" target="_blank" rel="noopener noreferrer" onClick={closeMobileNav}>
                                SOP
                            </a>
                        </li>
                        <li>
                            <a href="https://short.sampangkab.go.id/851526-42992" onClick={closeMobileNav}>Buku Pedoman</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>,
        document.body
    );
};

export default MobileMenu;